/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

const MailToLink = (props) => {
  return (
    <a className={props.className} href={`mailto:${props.email}`}>
      {props.children}
    </a>
  );
};
MailToLink.propTypes = {
  children: PropTypes.any.isRequired,
  email: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default MailToLink;
